<div>
  <button class="btn btn-primary" (click)="validate()" style="margin: 20px">Run Validation</button>

  <div class="row">
    <div class="col-md-6">
      <p *ngIf="isNotLatestVersion">*This inspection wasn't performed using the latest version.</p>
      <div class="row" *ngIf="!showPictures && items?.length">
        <div class="col-md-4">
          <h4>Item</h4>

          <ul class="list-group">
            <li
              class="list-group-item"
              *ngFor="let item of items; index as i"
              [ngStyle]="{ 'background-color': selectedItemIndex === i ? '#eee' : '#fff' }"
              (click)="selectedItemIndex = i">
              <div class="row">
                <div class="col-md-2" *ngIf="item.errors">
                  <i class="fa fa-close" style="font-size: 30px; color: red"></i>
                </div>
                <div [ngClass]="{ 'col-md-10': item.errors, 'col-md-12': !item.errors }">
                  <p>{{ item.label }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <h4>Section</h4>

          <ul class="list-group">
            <ng-container *ngFor="let item of sections; index as i">
              <li
                class="list-group-item"
                *ngIf="item.show"
                [ngStyle]="{ 'background-color': selectedSectionIndex === i ? '#eee' : '#fff' }"
                (click)="selectedSectionIndex = i">
                <div class="row">
                  <div class="col-md-2" *ngIf="item.errors">
                    <i class="fa fa-close" style="font-size: 30px; color: red"></i>
                  </div>
                  <div [ngClass]="{ 'col-md-10': item.errors, 'col-md-12': !item.errors }">
                    <p>{{ item.name }}</p>
                  </div>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>
        <div class="col-md-4">
          <h4>Question</h4>

          <ul class="list-group">
            <ng-container *ngFor="let item of questions; index as i">
              <li
                class="list-group-item"
                *ngIf="item.show"
                [ngStyle]="{ 'background-color': selectedQuestionIndex === i ? '#eee' : '#fff' }"
                (click)="selectedQuestionIndex = i">
                <div class="row">
                  <div class="col-md-2" *ngIf="hasError(item)">
                    <i class="fa fa-close" style="font-size: 30px; color: red"></i>
                  </div>
                  <div [ngClass]="{ 'col-md-10': hasError(item), 'col-md-12': !hasError(item) }">
                    {{ item.text }}
                  </div>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>

      <div class="row" *ngIf="showPictures">
        <div class="col-12">
          <app-answer-pictures (close)="forceMenu = true" [answer]="picturesAnswer"></app-answer-pictures>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card" *ngIf="question">
        <div class="card-body">
          <div *ngIf="question.validation?.length" style="color: red">
            <h5>Validation Errors</h5>
            <ul>
              <li *ngFor="let e of question.validation">{{ e.error }}</li>
            </ul>
          </div>
          <h4>{{ question.legacyId ? '(' + question.legacyId + ')' : '' }} {{ question.text }}</h4>
          <br />

          <div *ngIf="question.type == 'pick-list'">
            <h5>Options</h5>

            <ul>
              <li *ngFor="let o of question?.options">{{ o?.text }}</li>
            </ul>
          </div>

          <div class="row">
            <div class="col-xl-12" *ngFor="let a of question.answer; index as i">
              <div class="card">
                <div class="card-header">Building #{{ a.buildingIndex || 1 }}</div>
                <div class="card-body">
                  <app-answer-invalid-form
                    [answer]="a"
                    [question]="question"
                    [readOnly]="false"
                    (statusChange)="answerStatusChange($event)"
                    (setPictures)="answerSetPictures($event)">
                  </app-answer-invalid-form>
                  <button class="btn btn-danger" (click)="removeAnswer(a.id)">Remove Answer</button>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-secondary" (click)="addAnswer()">Add Answer</button>
        </div>
      </div>
    </div>
  </div>
</div>
